/**
 * JSON-backed localStorage access that never throws.
 *
 * Returns `fallback` when the key is absent, the value does not parse, or
 * storage is unavailable (private mode, SSR, quota). Note the explicit
 * `null` check rather than a truthiness test, so a stored `false` or `0`
 * survives the round trip.
 */
export const readJsonLocal = <T,>(key: string, fallback: T): T => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
};

export const writeJsonLocal = (key: string, value: unknown): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable — the setting is a convenience, not state we must keep */
  }
};
